import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {FusePageSimple} from '../../../../@fuse/index';
import UecareListHeader from "../../../../components/header/UecareListHeader";
import CallRecordList from "./CallRecordList";
import { LinearProgress, Tab, Tabs } from '@material-ui/core/index'
import ReduxCallRecord from "../../../../store/actionreducers/callRecord";

class CallRecord extends Component {

    state = {
        tabValue: 0,
        calls: [],
    };

    handleChangeTab = async (event, tabValue) => {
        if (this.state.tabValue === tabValue) return
        this.setState({ tabValue })
        await this._reload()
    }

    async componentDidMount() {
        await this._reload()
    }

    async _reload() {
        this.setState({ isLoading: true })
        const calls = await (this.state.tabValue ? this.props.fetchIncoming : this.props.fetchHistory)()
        this.setState({ isLoading: false, calls })
    }

    render() {
        const {classes} = this.props;
        const {tabValue, calls} = this.state;

        return (
            <React.Fragment>
                <FusePageSimple
                    className={classes.root}
                    classes={{
                        root: classes.layoutRoot,
                        contentCardWrapper: classes.layoutContentCardWrapper,
                        leftSidebar: classes.layoutLeftSidebar
                    }}
                    header={
                        <UecareListHeader title='客服通話列表' icon='call' reload={() => this._reload()} />
                    }

                    contentToolbar={
                        <div style={{ width: '100%' }}>
                            <LinearProgress
                                color="secondary"
                                style={{ visibility: this.state.isLoading ? 'visible' : 'hidden' }}
                            />
                            <Tabs
                                value={tabValue}
                                onChange={this.handleChangeTab}
                                indicatorColor="secondary"
                                textColor="secondary"
                                scrollable
                                scrollButtons="auto"
                                classes={{ root: 'w-full h-40' }}
                                className='bg-grey-light'>
                                <Tab className="h-40 normal-case font-extrabold" label="歷史紀錄" />
                                <Tab className="h-40 normal-case font-extrabold" label="進行中" />
                            </Tabs>
                        </div>
                    }

                    content={
                        <CallRecordList calls={calls}/>
                    }
                    sidebarInner
                />
            </React.Fragment>
        )
    };
}

const headerHeight = 160;

const styles = theme => ({
    root: {},
    layoutHeader: {
        height: headerHeight,
        minHeight: headerHeight
    },
    layoutContentCardWrapper: {
        padding: 16,
    },
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchHistory: ReduxCallRecord.ActionCreator.fetchHistory,
        fetchIncoming: ReduxCallRecord.ActionCreator.fetchIncoming,
    }, dispatch);
}

function mapStateToProps({mission: {list}}) {
    return {
        missions: list,
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CallRecord)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/callRecord/CallRecord.js